import { gql } from '@apollo/client'

export const Query = gql`
  query EditEventContact($companyId: ID!, $eventId: ID!, $eventContactId: ID!) {
    events(companyId: $companyId, filters: { idEq: $eventId }, first: 1) {
      nodes {
        id
        eventContacts(filters: { idEq: $eventContactId }, first: 1) {
          nodes {
            id
            user { id }
            name
            email
            phone
            contactType
          }
        }
      }
    }
  }
`
